import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { browserHistory } from 'react-router';
import classNames from 'classnames';

import EventCard from '../EventCard';
import ShareModal from '../../ShareModal';
import SlideOutMenu from '../../SlideOutMenu';
import AdSection from '../../AdSection';
import SiteNav from '../../SiteNav';
import MyEverdaysPanel from '../../MyEverdaysPanel';
import FbShareBtn from '../../FbShareBtn';
import FbShareSection from '../../FbShareSection';

import { getBaseRoute } from '../../WebCommunity';
import GetLinkCard from '../../GetLinkCard';

import { webCommunityOperations } from '@evdy/web-redux/dist/lib/webCommunity';

import { useScrollToTop, useFBShareRender } from '@evdy/web-core/dist/customHooks';

import styles from './EventDetailsPage.module.scss';
import './EventDetailsPage.scss';

const { trackAds } = webCommunityOperations;

const {
  'community-event-details-page': communityEventsClass,
  'decedent-bar-btn': decedentBarBtnClass,
  'events-contents': eventsContentsClass,
  'events-column': eventsColumnClass,
  'events-section': eventsSectionClass,
  'event-details-dropdown-overlay': eventModalOverlayClass,
  'overlay-on': overlayOnClass,
  'events-header-container': headerContainerClass,
  'title-container': titleContainerClass,
  'go-back': goBackClass,
  'fb-like': fbLikeClass,
  'my-everdays-panel-container': myEverdaysPanelContainerClass
} = styles;

const EventsHeader = ({ shareUrl = '', handleGoBack = () => {} }) => {
  return (
    <div className={headerContainerClass}>
      <div className={goBackClass} onClick={handleGoBack}>
        {'← Back'}
      </div>
    </div>
  );
};

const EventDetailsPage = ({ location }) => {
  const { eventsArray = [], inviteMeta } = useSelector(({ webCommunity }) => ({
    eventsArray: webCommunity.events.array,
    inviteMeta: webCommunity.inviteMeta.data
  }));
  const { _id: memorialId, ads = [], shareUrl = '' } = inviteMeta || {};

  const placementType = 'communityEventDetails';
  const findAdsCb = ({ placementType: adDataPlacementType }) =>
    placementType === adDataPlacementType;
  const eventDetailsAdData = !!ads.length && ads.find(findAdsCb);

  const [isOverlay, setIsOverlay] = useState(false);
  const [isShareModalOpen, setShareModalOpen] = useState(false);
  const [isMenuOpen, setMenuOpen] = useState(false);

  // scroll to top on mount
  useScrollToTop();

  // parse fb share content to be visible when navigating pages
  useFBShareRender();

  // inject custom click handler into every calendar element
  useEffect(() => {
    const addToCalNodeArr = document.getElementsByClassName('add-calendar');
    const handleSetOverlay = () => setIsOverlay(true);
    [...addToCalNodeArr].forEach(node => node.addEventListener('click', handleSetOverlay));

    return () => {
      [...addToCalNodeArr].forEach(node => node.removeEventListener('click', handleSetOverlay));
    };
  }, []);

  const closeOverlayFn = isOverlay ? () => setIsOverlay(false) : () => {};

  const handleGoBack = () => browserHistory.push(getBaseRoute(location.pathname));

  const handleToggleShareMenu = () => {
    setShareModalOpen(prev => !prev);
  };

  const DecedentBarBtn = () => (
    <button className={decedentBarBtnClass} onClick={handleToggleShareMenu}>
      Share
    </button>
  );

  const overlayClasses = classNames(eventModalOverlayClass, {
    [overlayOnClass]: isOverlay === true
  });

  return (
    <div className={`${communityEventsClass} community-event-details-page`}>
      <SiteNav showDecedentBar decedentBarContent={DecedentBarBtn} />
      <div className={eventsContentsClass}>
        <div className={eventsColumnClass}>
          <EventsHeader {...{ shareUrl, handleGoBack }} />
          <div className={titleContainerClass}>
            <h2>Events &amp; Services</h2>
            <FbShareBtn {...{ shareUrl }} fbShareClass={fbLikeClass} />
          </div>
          <div className={eventsSectionClass}>
            {eventsArray.map((event, idx) => (
              <EventCard {...{ event }} closeOverlayFn={closeOverlayFn} key={idx} />
            ))}
          </div>
        </div>
        {/* <div className={myEverdaysPanelContainerClass}>
          <MyEverdaysPanel />
        </div> */}
      </div>
      <FbShareSection {...{ shareUrl }} />
      <GetLinkCard />
      <AdSection {...{ trackAds, memorialId }} adData={eventDetailsAdData} />
      <ShareModal
        closeModal={handleToggleShareMenu}
        modalVisible={isShareModalOpen}
        shareUrl={inviteMeta?.shareUrl}
      />
      <SlideOutMenu {...{ isMenuOpen }} closeMenu={() => setMenuOpen(false)} />
      <div className={overlayClasses} onClick={closeOverlayFn} />
    </div>
  );
};

export default EventDetailsPage;
